( function( $ ) {
	if ( $( '.faq__list' ).length > 0 ) {
		$( '.faq__item__title' ).on( 'click', function() {
			$( this )
				.parent()
				.toggleClass( 'faq-open' );
		} );
	}
} )( jQuery );
